import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col md:flex-row" }
const _hoisted_2 = { class: "hidden md:block bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_3 = { class: "grid md:grid-cols-4 gap-4" }
const _hoisted_4 = { class: "flex justify-end mt-7" }
const _hoisted_5 = { class: "bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_6 = { class: "grid gap-4" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "flex justify-end mt-7" }
const _hoisted_9 = { class: "flex justify-end items-center md:flex-grow" }
const _hoisted_10 = {
  class: "md:hidden",
  style: {"height":"calc(100vh - 177px)"}
}
const _hoisted_11 = { class: "custom-title flex flex-col" }
const _hoisted_12 = { class: "ml-auto" }
const _hoisted_13 = { class: "flex items-center space-x-1" }
const _hoisted_14 = { style: {"height":"calc(100vh - 227px)","overflow-y":"auto"} }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "hidden md:block w-full" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "flex w-full justify-end mt-4" }
const _hoisted_19 = { class: "hidden md:block mr-3" }
const _hoisted_20 = { class: "md:hidden" }
const _hoisted_21 = { class: "flex flex-col md:flex-row" }
const _hoisted_22 = { class: "w-full md:w-full" }
const _hoisted_23 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_mian = _resolveComponent("el-mian")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { style: {"height":"calc(100vh - 52px)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, {
          style: {"height":"auto"},
          class: "bg-gray-200 p-3 md:p-5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form, {
                  model: _ctx.searchForm,
                  "label-width": "auto",
                  "label-position": "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "JANコード"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.searchForm.codeNumber,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.codeNumber) = $event)),
                            placeholder: "JANコード"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "商品名"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.searchForm.itemName,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.itemName) = $event)),
                            placeholder: "商品名"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "会社名"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.searchForm.makerName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.makerName) = $event)),
                            placeholder: "会社名"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_button, {
                          class: "hidden md:block w-24",
                          type: "info",
                          onClick: _ctx.getMngJancodes
                        }, {
                          default: _withCtx(() => _cache[28] || (_cache[28] = [
                            _createTextVNode("検索")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _createVNode(_component_el_drawer, {
                class: "md:hidden bg-gray-200",
                modelValue: _ctx.drawer,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.drawer) = $event)),
                title: "検索",
                direction: "ttb",
                "with-header": false,
                size: "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_form, {
                      model: _ctx.searchForm,
                      "label-width": "auto",
                      "label-position": "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "JANコード"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.searchForm.codeNumber,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchForm.codeNumber) = $event)),
                                placeholder: "JANコード"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "商品名"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.searchForm.itemName,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchForm.itemName) = $event)),
                                placeholder: "商品名"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_el_form_item, {
                              class: "no-margin flex-grow",
                              label: "会社名"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.searchForm.makerName,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchForm.makerName) = $event)),
                                  placeholder: "会社名"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_el_button, {
                                class: "md:hidden ml-3",
                                type: "info",
                                onClick: _ctx.getMngJancodes,
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                                      _createElementVNode("span", { class: "material-symbols-outlined" }, "manage_search", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn md:hidden",
                  type: "info",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.drawer = true)),
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " manage_search ", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn md:hidden",
                  type: "info",
                  onClick: _ctx.handleAddButton,
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " add ", -1)
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "hidden md:block w-24",
                  type: "info",
                  onClick: _ctx.handleAddButton
                }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createTextVNode("新規登録")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_mian, { style: {"padding-bottom":"20px"} }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[36] || (_cache[36] = _createElementVNode("span", null, "JANコードマスタ（JANコード　商品名）", -1)),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-white" }, "ソート:", -1)),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSort('codeNumber'))),
                      class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'codeNumber' ? 'active' : ''])
                    }, {
                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                        _createTextVNode(" JANコード ")
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleSort('itemName'))),
                      class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'itemName' ? 'active' : ''])
                    }, {
                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                        _createTextVNode(" 商品名 ")
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createElementVNode("span", null, "アイテム数: " + _toDisplayString(_ctx.totalRecords), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item) => {
                  return (_openBlock(), _createBlock(_component_el_card, {
                    style: {"border":"1px solid #d1d5db","border-radius":"0px"},
                    key: item.codeNumber
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { align: "middle" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 2 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "w-8 h-16",
                                type: "info",
                                style: {"background-color":"#b7b7b7"},
                                text: "",
                                bg: "",
                                onClick: ($event: any) => (_ctx.handleEdit(item))
                              }, {
                                default: _withCtx(() => _cache[37] || (_cache[37] = [
                                  _createElementVNode("span", null, [
                                    _createTextVNode("詳"),
                                    _createElementVNode("br"),
                                    _createTextVNode("細")
                                  ], -1)
                                ])),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, {
                            span: 18,
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, _toDisplayString(item.codeNumber), 1),
                              _createElementVNode("div", null, _toDisplayString(item.itemName), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, {
                            span: 2,
                            class: "ml-2",
                            align: "right"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: "material-symbols-outlined cursor-pointer",
                                onClick: ($event: any) => (_ctx.handleDelete(item))
                              }, " delete ", 8, _hoisted_15)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_16, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                data: _ctx.tableData,
                height: "calc(100vh - 260px)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "JANコードマスタ",
                    width: "140",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        class: "w-12",
                        type: "info",
                        style: {"background-color":"#b7b7b7"},
                        text: "",
                        bg: "",
                        onClick: ($event: any) => (_ctx.handleEdit(scope.row))
                      }, {
                        default: _withCtx(() => _cache[38] || (_cache[38] = [
                          _createElementVNode("span", null, "詳細", -1)
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "codeNumber",
                    label: "JANコード",
                    width: "160"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSort('codeNumber')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('codeNumber')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'codeNumber' }])
                            }, _toDisplayString(_ctx.getSortIcon('codeNumber')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "itemName",
                    label: "商品名",
                    "min-width": "400"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSort('itemName')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('itemName')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'itemName' }])
                            }, _toDisplayString(_ctx.getSortIcon('itemName')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "makerName",
                    label: "会社名",
                    width: "280"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleSort('makerName')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('makerName')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'makerName' }])
                            }, _toDisplayString(_ctx.getSortIcon('makerName')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "削除",
                    width: "52",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", {
                        class: "material-symbols-outlined cursor-pointer mt-2",
                        onClick: ($event: any) => (_ctx.handleDelete(scope.row))
                      }, " delete ", 8, _hoisted_17)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_loading, _ctx.loading]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.currentPage,
                  "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.currentPage) = $event)),
                  "page-size": _ctx.pageSize,
                  "onUpdate:pageSize": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.pageSize) = $event)),
                  "page-sizes": [10, 20, 50, 100],
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _ctx.totalRecords,
                  onSizeChange: _ctx.handleSizeChange,
                  onCurrentChange: _ctx.handlePageChange
                }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next",
                  total: _ctx.totalRecords,
                  onCurrentChange: _ctx.handlePageChange
                }, null, 8, ["total", "onCurrentChange"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      style: {"max-width":"800px"},
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: _ctx.form.add_update === _ctx.Operation.add ? '新規登録' : '詳細',
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_el_button, {
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withCtx(() => _cache[39] || (_cache[39] = [
              _createTextVNode("キャンセル")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submitForm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.form.add_update === 'add' ? '登録' : '更新'), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_el_form, {
              ref: "formRef",
              model: _ctx.form,
              rules: _ctx.rules,
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                (_ctx.form.add_update === _ctx.Operation.add)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "JANコード",
                      prop: "codeNumber",
                      error: _ctx.errors.codeNumber
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.codeNumber,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.codeNumber) = $event)),
                          autocomplete: "off",
                          placeholder: "JANコード"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["error"]))
                  : (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "コード番号",
                      prop: "codeNumber"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.codeNumber,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.codeNumber) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })),
                _createVNode(_component_el_form_item, {
                  label: "コードタイプ",
                  prop: "codeType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.codeType,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.codeType) = $event)),
                      autocomplete: "off",
                      placeholder: "コードタイプ"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "商品名",
                  prop: "itemName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.itemName,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.itemName) = $event)),
                      autocomplete: "off",
                      placeholder: "商品名"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "品番(型番)",
                  prop: "itemModel"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.itemModel,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.itemModel) = $event)),
                      autocomplete: "off",
                      placeholder: "型番"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "詳細ページURL",
                  prop: "itemUrl"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.itemUrl,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.itemUrl) = $event)),
                      autocomplete: "off",
                      placeholder: "詳細ページURL"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "商品画像URL",
                  prop: "itemImageUrl"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.itemImageUrl,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.itemImageUrl) = $event)),
                      autocomplete: "off",
                      placeholder: "画像URL"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "ブランド名",
                  prop: "brandName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.brandName,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.brandName) = $event)),
                      autocomplete: "off",
                      placeholder: "ブランド名"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "メーカー名",
                  prop: "makerName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.makerName,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.makerName) = $event)),
                      autocomplete: "off",
                      placeholder: "メーカー名"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "会社名(カナ)",
                  prop: "makerNameKana"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.makerNameKana,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.makerNameKana) = $event)),
                      autocomplete: "off",
                      placeholder: "メーカー"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "商品追加情報",
                  prop: "productDetail"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.productDetail,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.productDetail) = $event)),
                      autocomplete: "off",
                      placeholder: "商品詳細"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}